export const formatInitialPhone = (value: string) => {
  value.replace(/[^\d]/g, "");
  return `(${value.slice(0, 3)}) ${value.slice(3, 6)}-${value.slice(6, 10)}`;
};
